import { QueryTuple, useLazyQuery } from '@apollo/client';
import { AppDataFormat } from '@bechtel/types';
import { GET_APP_DATA_FORMATS } from '@bechtel/client-gql';

export function useAppDataFormats(
  fetchFromNetwork?: boolean
): QueryTuple<{ dateFormatData: AppDataFormat[] }, Record<string, any>> {
  const response = useLazyQuery<{
    dateFormatData: AppDataFormat[];
  }>(
    GET_APP_DATA_FORMATS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
